import { formOptions } from '@tanstack/react-form';

export type AdminDomainFormData = {
  name: string;
  parentDomainId?: string | null;
  subdomains?: string[];
};

export const adminDomainFormOptions = formOptions({
  defaultValues: {
    name: '',
    parentDomainId: null,
    subdomains: [],
  } as AdminDomainFormData,
});
